<div class="themes">
    <div class="themes-header">
        <tools-button routerLink="/admin/themes/new">
            Create New Theme
        </tools-button>
    </div>
    @if (showEmptyState()) {
        <section class="empty" aria-label="Empty state">
            <h3>No Themes Yet</h3>
            <p>
                Create a theme to start branding producer, host, and
                admin-facing views.
            </p>
        </section>
    } @else {
        <tools-table [dataSource]="dataSource" [format]="tableFormat">
            <ng-template #custom let-row="data">
                <a
                    class="themes-edit-action"
                    [routerLink]="['/admin/themes', row.data.id, 'edit']"
                >
                    <span class="icon-edit"></span>
                    Edit
                </a>
            </ng-template>
        </tools-table>
        <tools-paginator [variant]="paginatorVariant"></tools-paginator>
    }
</div>
